// Local pricing plans data for PricingPage
// Shapes follow the previous backend response structure used in PricingPage
// - id: string (UI key)
// - api_id: number (backend plan id)
// - name: 'Seed' | 'Root' | 'Bloom' | 'Thrive'
// - description: short tagline
// - price_per_month: number (0 for Free)
// - features: Array<{ id: string, name: string, description?: string }>

export const PRICING_PLANS = [
  {
    id: 'seed',
    api_id: 1,
    name: 'Seed',
    description: 'Test the soil',
    price_per_month: 0,
    features: [
      { id: 'seed-1', name: '[icon:flower] SKU Limit - 10' },
      { id: 'seed-2', name: '[icon:flower] Commission Fee - 25%' },
      { id: 'seed-3', name: '[icon:flower] Transaction Fee - 5%' },
      { id: 'seed-4', name: '[icon:cross] Shipping Credits - 0' },
      { id: 'seed-5', name: '[icon:cross] InSpire Landing Page' },
      { id: 'seed-6', name: '[icon:cross] Free Marketing' },
      { id: 'seed-7', name: '[icon:flower] 80K Guaranteed Impressions' },
      { id: 'seed-8', name: '[icon:flower] Growth Suite Credits - 5' },
      { id: 'seed-9', name: '[icon:flower] Add-on Credits @ ₹126 / Credit' },
      { id: 'seed-10', name: '[icon:flower] 3S Certification' },
      { id: 'seed-11', name: '[icon:flower] TARA AI Bot' },
      { id: 'seed-12', name: '[icon:cross] Suspire Support Network' },
      { id: 'seed-13', name: '[icon:cross] Suspire Seller University' },
    ],
  },
  {
    id: 'root',
    api_id: 2,
    name: 'Root',
    description: 'Dig in',
    price_per_month: 18999,
    features: [
      { id: 'root-1', name: '[icon:flower] SKU Limit - 20' },
      { id: 'root-2', name: '[icon:flower] Commission Fee - 22%' },
      { id: 'root-3', name: '[icon:flower] Transaction Fee - 5%' },
      { id: 'root-4', name: '[icon:flower] Shipping Credits - 120' },
      { id: 'root-5', name: '[icon:flower] InSpire Landing Page - Pro Version' },
      { id: 'root-6', name: '[icon:flower] Free Marketing + Digital Ads' },
      { id: 'root-7', name: '[icon:flower] 6L+ Guaranteed Impressions (with SP)' },
      { id: 'root-8', name: '[icon:flower] Growth Suite Credits - 50' },
      { id: 'root-9', name: '[icon:flower] Add-on Credits @ ₹117 / Credit' },
      { id: 'root-10', name: '[icon:flower] 3S Certification' },
      { id: 'root-11', name: '[icon:flower] TARA AI Bot' },
      { id: 'root-12', name: '[icon:flower] Suspire Support Network' },
      { id: 'root-13', name: '[icon:flower] Suspire Seller University' },
    ],
  },
  {
    id: 'bloom',
    api_id: 3,
    name: 'Bloom',
    description: 'Show your colours',
    price_per_month: 69399,
    features: [
      { id: 'bloom-1', name: '[icon:check] SKU Limit - 40' },
      { id: 'bloom-2', name: '[icon:check] Commission Fee - 10%' },
      { id: 'bloom-3', name: '[icon:check] Transaction Fee - 5%' },
      { id: 'bloom-4', name: '[icon:check] Shipping Credits - 120' },
      { id: 'bloom-5', name: '[icon:check] InSpire Landing Page - Pro Version' },
      { id: 'bloom-6', name: '[icon:check] Free Marketing + Digital Ads + Social Media Ads' },
      { id: 'bloom-7', name: '[icon:check] 6L+ Guaranteed Impressions (with SP)' },
      { id: 'bloom-8', name: '[icon:check] Growth Suite Credits - 75' },
      { id: 'bloom-9', name: '[icon:check] Add-on Credits @ ₹108 / Credit' },
      { id: 'bloom-10', name: '[icon:check] 3S Certification + Print Merchandise + Dedicated Page' },
      { id: 'bloom-11', name: '[icon:check] TARA AI Bot' },
      { id: 'bloom-12', name: '[icon:check] Suspire Support Network' },
      { id: 'bloom-13', name: '[icon:check] Suspire Seller University' },
    ],
  },
  {
    id: 'thrive',
    api_id: 4,
    name: 'Thrive',
    description: 'Own the canopy',
    price_per_month: 119799,
    features: [
      { id: 'thrive-1', name: '[icon:check] SKU Limit - 80' },
      { id: 'thrive-2', name: '[icon:check] Commission Fee - 0%' },
      { id: 'thrive-3', name: '[icon:check] Transaction Fee - 5%' },
      { id: 'thrive-4', name: '[icon:check] Shipping Credits - 180' },
      { id: 'thrive-5', name: '[icon:check] InSpire Landing Page - Pro Version' },
      { id: 'thrive-6', name: '[icon:check] Free Marketing + Digital Ads + Social Media Ads + Community Ads' },
      { id: 'thrive-7', name: '[icon:check] 12L+ Guaranteed Impressions (with SP)' },
      { id: 'thrive-8', name: '[icon:check] Growth Suite Credits - 100' },
      { id: 'thrive-9', name: '[icon:check] Add-on Credits @ ₹99 / Credit' },
      { id: 'thrive-10', name: '[icon:check] 3S Certification + Print Merchandise + Dedicated Community' },
      { id: 'thrive-11', name: '[icon:check] TARA AI Bot' },
      { id: 'thrive-12', name: '[icon:check] Suspire Support Network' },
      { id: 'thrive-13', name: '[icon:check] Suspire Seller University' },
    ],
  },
];
